<template>
	<div class="content-wapper">
		<el-row class="navigation">
			<el-col align="left">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
<!--					<el-breadcrumb-item :to="{ path: '' }">质量提升综合服务</el-breadcrumb-item>-->
					<el-breadcrumb-item :to="{ path: '/main/zltszhfw/pxfw' }">培训服务</el-breadcrumb-item>
					<el-breadcrumb-item> 详情</el-breadcrumb-item>
				</el-breadcrumb>
			</el-col>
		</el-row>
		<el-row class="content">
			<el-col :span="18">
				<el-row>
					<el-col :span="24">
						<video-player v-if="videoShow"
							class="video-player vjs-custom-skin"
							ref="videoPlayer"
							name="videoPlayer"
							id="video"
							:playsinline="true"
							:options="playerOptions"
							@play="onPlayerPlay($event)"
							@pause="onPlayerPause($event)"
							@ended="onPlayerEnded($event)"
							@waiting="onPlayerWaiting($event)"
							@timeupdate="onPlayerTimeupdate($event)"
							@statechanged="playerStateChanged($event)"
							@canplaythrough="onPlayerCanplaythrough($event)"
							@ready = "playerReadied"
						></video-player>
					</el-col>
				</el-row>
			</el-col>
			<el-col :span="6" style="padding-left: 0.625rem;">
				<el-row>
					<div class="titleClass">
						<span  style="font-family: 微软雅黑, 宋体">{{detail.title}}</span>
					</div>
					<div class="durationClass">
						<el-tag  type="info">时长：{{detail.duration}}</el-tag>
					</div>
					<el-col :span="12" class="colcla">
						<span>培训老师：{{detail.teacher}}</span>
					</el-col>
					<el-col :span="12" class="colcla">
						<span>访问次数：{{browseCount}}</span>
					</el-col>
					<div class="fontcla">
						<span>发布时间：{{ parseTime(detail.fbtime, '{y}-{m}-{d}') }}</span>
					</div>
					<div class="fontcla">
						<span>来源：威海市市场监督管理局<!--{{detail.source}}--></span>
					</div>
				</el-row>
				<el-row style="background-color:rgba(136,136,136,0.5);margin-top:2.725rem ;min-height: 18.75rem;padding: 0.625rem;">
					<div class="downtitle">
						<span>课件/资料下载</span>
					</div>
					<div v-for=" item in detail.sysAttachments" style="border-bottom: 1px dashed #cccccc;text-align: left;padding: 0.3125rem 0;">
						<el-link :underline="false" @click="resourceDownload(item.path)">{{item.fileName}}</el-link>
					</div>
				</el-row>
			</el-col>
		</el-row>
		<el-row class="content2">
			<el-col :span="24">
				<div class="titleClass">
					{{detail.title}}
				</div>
				<div style="text-align:left;margin: 0.625rem 0;">
					<el-button type="info" plain size="mini" disabled>内容简介</el-button>
				</div>
				<div class="fontcla">
					{{detail.introduction.length <= 0 ? '暂无' :detail.introduction}}
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import { videoPlayer } from "vue-video-player";
	import "video.js/dist/video-js.css";
	import "vue-video-player/src/custom-theme.css";
	import {
		getBrowseCount
	} from "@/api/basedata/records";
	export default {
		name:'vedioDetail',
		components: {
			videoPlayer
		},
		data() {
			return {
				videoShow:true,
				// 遮罩层
				loading: true,
				recid: undefined,
				type: undefined,
				detail: {},
				menulist: [{
						code: 'zscq',
						title: '知识产权'
					},
					{
						code: 'zlts',
						title: '质量提升'
					},
					{
						code: 'xwqy',
						title: '小微企业成长'
					},
					{
						code: 'pxgg',
						title: '培训公告'
					},
					{
						code: 'pxzl',
						title: '培训资料'
					},
				],
				ywViews:{
					busRecid:undefined,
					busTableName:'yw_ycjygypx_pxzl',
				},
				playTime:'',
				current:'',
				browseCount: 0,
				playerOptions: {
					playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
					autoplay: false, // 如果为true,浏览器准备好时开始回放。
					muted: false, // 默认情况下将会消除任何音频。
					loop: false, // 是否视频一结束就重新开始。
					preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
					language: "zh-CN",
					aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
					fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
					sources: [
						{
							type: "video/mp4", // 类型
							src:''// url地址
						}
					],
					poster: "", // 封面地址
					notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
					controlBar: {
						timeDivider: true, // 当前时间和持续时间的分隔符
						durationDisplay: true, // 显示持续时间
						remainingTimeDisplay: false, // 是否显示剩余时间功能
						fullscreenToggle: true // 是否显示全屏按钮
					},
				},
			}
		},
		created() {
			this.detail = JSON.parse(localStorage.getItem('vedioDetail'));
			this.recid = this.detail.recid;
			// console.log("dddd",this.detail)
			this.getBrowseData();
		},
		mounted(){
			this.playerOptions.sources[0].src = this.getImgUrl(this.detail.vedioPath);
			this.playerOptions.poster=this.getImgUrl(this.detail.imgPath);
		},
		methods: {
			toPage(url) {
				this.$router.push({
					path: url,
				});
				this.$store.commit('SET_MAININDEX', url);
			},
			getBrowseData() {
				this.ywViews.busRecid= this.recid;
				getBrowseCount(this.ywViews).then(response => {
					this.browseCount = response;
				})
			},
			// 播放回调
			onPlayerPlay(player) {
				// console.log("player play!", player);
			},

			// 暂停回调
			onPlayerPause(player) {
				// console.log("player pause!", player);
			},

			// 视频播完回调
			onPlayerEnded($event) {
				// console.log(player);
			},
			// DOM元素上的readyState更改导致播放停止
			onPlayerWaiting(player) {
				let time = localStorage.getItem("cacheTime")
				if(player.cache_.currentTime - Number(time) > 0.1){
					this.current = Number(time)
					this.playerReadied(player)
				}else{
					this.current = player.cache_.currentTime
				}
			},

			// 已开始播放回调
			onPlayerPlaying($event) {
				// console.log(player)
			},

			// 当播放器在当前播放位置下载数据时触发
			onPlayerLoadeddata($event) {
				// console.log(player)
			},

			// // 当前播放位置发生变化时触发。
			onPlayerTimeupdate(player) {
				this.playTime = player.cache_.currentTime
				let playTime = player.cache_.currentTime
				setTimeout(function () {
					localStorage.setItem("cacheTime",playTime)
				},500)


				let time = localStorage.getItem("cacheTime")
				if(player.cache_.currentTime - Number(time) > 2){
					this.current = Number(time)
					this.playerReadied(player)
				}else{
					this.current = player.cache_.currentTime
				}
			},

			//媒体的readyState为HAVE_FUTURE_DATA或更高
			onPlayerCanplay(player) {
				// console.log('player Canplay!', player)
			},

			//媒体的readyState为HAVE_ENOUGH_DATA或更高。这意味着可以在不缓冲的情况下播放整个媒体文件。
			onPlayerCanplaythrough(player) {
				// console.log('player Canplaythrough!', player)
			},

			//播放状态改变回调
			playerStateChanged(playerCurrentState) {
				// console.log('player current update state', playerCurrentState)
			},

			//将侦听器绑定到组件的就绪状态。与事件监听器的不同之处在于，如果ready事件已经发生，它将立即触发该函数。。
			playerReadied(player) {
				// console.log('example player 1 readied', player);
				player.currentTime(this.current)
			},
			handleDownload(file){
			  var name = file.fileName;
			  var url = file.filePath;
			  const a = document.createElement('a');
			  a.setAttribute('download', name);
			  a.setAttribute('target', '_blank');
			  a.setAttribute('href', process.env.VUE_APP_BASE_API+url);
			  a.click();
			}
		}
	}
</script>

<style scoped="scoped">
	.content-wapper {
		margin-top: 15px;
		padding: 10px;
		margin-bottom: 1.875rem;
		background-color: #000000;
	}

	.navigation {
		padding: 15px;
		line-height: 10px;
		height: 40px;
		color: #f5f5f5;
	}
	/deep/ .el-link--inner{
		color: #f5f5f5;
	}
	.content {
		border: 1px solid #000000;
		padding:20px 20px 20px 0;
		min-height: 35rem;
	}
	.content2{
		border: 1px solid #000000;
		min-height: 10rem;
	}
	
	/deep/ .vjs-custom-skin > .video-js .vjs-big-play-button {
		background-color: rgba(0,0,0,0.45);
		font-size: 3.0em;
		/* border-radius: 50%; */
		height: 1.5em !important;
		line-height:1.5em !important;
		margin-top: -1em !important;
	}
	/*这里用了第三方vue-video-player插件，但这个插件有bug，设置globalSetting:{controls:true}隐藏进度条不生效，故可设置插件样式进行隐藏vjs-progress-contro*/
	.vjs-progress-control {
		/* visibility:hidden;       */
	}
	/deep/ .video-js .vjs-big-play-button{
	   /*
	   播放按钮换成圆形
	   */
	   height: 2em;
	   width: 2em;
	   line-height: 2em;
	   border-radius: 1em;
	}
	.titleClass{
		color: #FFFFFF;
		text-align: left;
		font-size: 1.125rem;
		font-weight: 700;
	}
	.durationClass{
		text-align: left;
		padding-top: 0.625rem;
	}
	.fontcla{
		color: #fffefc;
		text-align: left;
		padding-top: 0.625rem;
	}
	.colcla{
		color: #fffefc;
		text-align: left;
		padding-top: 1.875rem;
		padding-bottom: 0.625rem;
	}
	.downtitle{
		color: #ffaa00;
		font-size: 0.9375rem;
		text-align: left;
		margin-bottom: 0.625rem;
	}
	/deep/ .el-link--inner{
		color: #409EFF;
	}
	/deep/ .el-breadcrumb__inner.is-link, .el-breadcrumb__inner a {
		color: #FFFFFF;
	}
	/deep/ .el-breadcrumb__item:last-child .el-breadcrumb__inner, .el-breadcrumb__item:last-child .el-breadcrumb__inner a, .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover, .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover{
		color: #FFFFFF;
	}
</style>
